import React, { useEffect, useState, useContext } from 'react';
import {
  Col, Row, Table, Button, Container,
} from 'react-bootstrap';
import { useParams, Link } from 'react-router-dom';
import axiosInstance from '../../../../components/axios/axiosApi';
import { PageStyle } from './styles';
import UserAuthContext from '../../../../components/Context/userContext';

const DetailKumAdmin = () => {
  const userConsumer = useContext(UserAuthContext);
  const { idKum } = useParams();
  const [state, setState] = useState({
    nama_kegiatan: '',
    jenis_kegiatan: 'kuliah umum',
    tanggal: '',
    pukul: '',
    penyelenggara: '',
    nilai_kum: '',
    biaya: '',
    sertifikat: '',
    link_regis: 'https://',
    lokasi: '',
    pembicara: '',
  });

  const fetchData = () => {
    axiosInstance.get(`api/kuliah_umum/detail/${idKum}/`)
      .then((response) => {
        const body = response.data;
        const nilaiKumParsed = parseInt(body.nilai_kum, 10);
        const biayaParsed = parseInt(body.biaya, 10);
        setState({
          ...state,
          nama_kegiatan: body.nama_kegiatan,
          jenis_kegiatan: body.jenis_kegiatan,
          tanggal: body.tanggal,
          pukul: body.pukul,
          penyelenggara: body.penyelenggara,
          nilai_kum: nilaiKumParsed,
          biaya: biayaParsed,
          sertifikat: body.sertifikat,
          link_regis: body.link_regis,
          lokasi: body.lokasi,
          pembicara: body.pembicara,
          img_url: body.image_url,
        });
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const role = (userConsumer.role === 'admin' || userConsumer.role === 'superadmin');

  return (
    <Container className={PageStyle}>
      <Link to="/">
        <Button className="btn-kembali">
          Kembali
        </Button>
      </Link>
      <Row className="mt-3">
        <Col md={4}>
          <h3>
            { state.nama_kegiatan }
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={4} className="text-center">
          <img src={state.img_url} alt="Poster kum" id="img-detail" />
        </Col>
        <Col md={{ offset: 0 }}>
          <div>
            <Table responsive="sm">
              <tbody>
                <tr>
                  <td>Hari/Tanggal</td>
                  <td>{ state.tanggal }</td>
                </tr>
                <tr>
                  <td>Pukul</td>
                  <td>{ state.pukul }</td>
                </tr>
                <tr>
                  <td>Penyelenggara</td>
                  <td>{ state.penyelenggara }</td>
                </tr>
                <tr>
                  <td>Nilai KUM</td>
                  <td>{ state.nilai_kum}</td>
                </tr>
                <tr>
                  <td>Pembicara</td>
                  <td>{ state.pembicara }</td>
                </tr>
                <tr>
                  <td>Biaya</td>
                  <td>{ state.biaya }</td>
                </tr>
                <tr>
                  <td>Sertifikat</td>
                  <td>{ state.sertifikat }</td>
                </tr>
                <tr>
                  <td>Link Registrasi</td>
                  <td>{ state.link_regis }</td>
                </tr>
                <tr>
                  <td>Lokasi</td>
                  <td>{ state.lokasi }</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </Col>
      </Row>
      { role
        ? (
          <Row className="text-center justify-content-center">
            <Link to={`/Admin/EditKum/${idKum}`}>
              <Button className="btn-ubah text-center margin-auto">
                Ubah
              </Button>
            </Link>
          </Row>
        )
        : <></>}
    </Container>
  );
};

export default DetailKumAdmin;
